//class定義
class Chaffle {
  constructor(elem) {
    this.elem = elem;
    this.elemSprit;
    this.animating = false;
    this.speed = 100;
    this.duration = 100;
    this.chars = ['$', '%', '#', '&', '(', ')', '=', '*', '/', '+', '<'];
    this.animeSetting();
  }


  spritToSpan(elem){
    let value = elem;
    //テキスト取得
    let text = value.textContent;
    value.innerHTML = ``;
    let textSprit = text.split(``);
    let textSpritTotal = textSprit.length;

    //分割した文字をspanに入れてく
    for (let i = 0; i < textSpritTotal; i++) {
      let span = document.createElement(`span`);
      span.innerHTML = textSprit[i];
      value.appendChild(span);
    }
    return value;
  }

  getRandomInt(min , max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }


  animeSetting() {
    let newElem = this.spritToSpan(this.elem);
    this.elemSprit = newElem;
    //this.anime();
  }

  anime() {
    let spans = this.elemSprit.children;
    let spansTotal = spans.length;
    

    if (!this.animating) {
      this.animating = true;
      for (let j = 0; j < spansTotal; j++) {
        //文字取得してから文字を置き換える
        let txt = spans[j].innerHTML;
        let num = this.getRandomInt(0, this.chars.length - 1)
        let randTxt = this.chars[num];
        //spans[j].innerHTML = randTxt;
        let letterChaffle;
        //時間経過で
        letterChaffle = setTimeout(() => {
          let num = this.getRandomInt(0, this.chars.length - 1)
          let randTxt2 = this.chars[num];

          setTimeout(() => {

            spans[j].innerHTML = txt;
            if (j >= spansTotal - 1) this.animating = false;

          }, this.duration);

          spans[j].innerHTML = randTxt2;

        }, this.speed * (j + 1));

      }
    } else {

    }
  }

}
